import { useTranslation } from 'react-i18next'
import { SearchResultsProps } from 'src/components/SearchResults'
import { indexes, ResultItem } from 'src/meilisearch/types/Common'
import routes from 'src/routes/definitions'
import Router from 'src/routes/Router'

import { ImageTransformer } from '../Transformers/ImageTransformer'

export const useSearchResults = (
  results: Record<string, Array<ResultItem>>,
  locale: string,
  q: string
): SearchResultsProps => {
  const { t } = useTranslation()
  const items = Object.entries(results || {})
  return {
    title:
      items.length === 1
        ? t('searchPage.results.title_one', { count: items.length, q })
        : t('searchPage.results.title_other', { count: items.length, q }),
    results: items.map(([index, items]) => {
      return {
        title: t(`searchResults.section.${index}`),
        items: items.map((row) => {
          const route = (() => {
            switch (row.indexUid) {
              case indexes.Article:
                return routes.articles
              case indexes.Engagement:
                return routes.engagements
              case indexes.Job:
                return routes.jobs
              case indexes.Project:
                return routes.projects
              case indexes.Page:
                return routes.page
            }
          })()

          return {
            title: row?.title || row?.name || row?.pageTitle || '',
            ...(row?.description && {
              richTextProps: {
                html: row?.description,
              },
            }),
            ...(row?.hero?.desktopImage && {
              pictureProps: {
                imageProps: ImageTransformer({
                  attributes: row.hero.desktopImage,
                  id: 0,
                }),
                ...(row?.hero?.mobileImage && {
                  mobileImageProps: ImageTransformer({
                    attributes: row.hero.mobileImage,
                    id: 0,
                  }),
                }),
              },
            }),
            linkProps: {
              href: Router.getRouteUrl(route as any, {
                slug: row.slug,
              }),
              locale,
            },
          }
        }),
      }
    }),
  }
}
